<template>
  <el-form
      ref="form"
      :model="form"
      label-width="100px">
    <div class="form-row" style="padding-bottom: 16px;">
      <div class="form-col">
        <el-form-item
          label="广告活动名称"
          prop="campaignName"
          :rules="[
            { required: true, message: '请输入广告活动名称', trigger: ['blur', 'change'] }
          ]">
        <gj-input
            v-model="form.campaignName"
            width="334px"
            placeholder="请输入">
        </gj-input>
      </el-form-item>
      </div>
      <div class="form-col">
        <el-form-item
            label="广告活动时间"
            class="date-input-group">
          <el-form-item
              prop="startDate"
              :rules="[
                { required: true, message: '请选择开始日期', trigger: ['blur', 'change'] }
              ]">
            <gj-date-picker
                v-model="form.startDate"
                width="155px"
                :clearable="false"
                :disabledDate="startDisabledDate"
                placeholder="开始日期(必填)">
            </gj-date-picker>
          </el-form-item>
          <span style="margin: 0 10px">-</span>
          <el-form-item>
            <gj-date-picker
                v-model="form.endDate"
                width="155px"
                :disabledDate="endDisabledDate"
                placeholder="无结束日期(选填)">
            </gj-date-picker>
          </el-form-item>
        </el-form-item>
      </div>
    </div>
    <div class="form-row">
      <div class="form-col">
        <el-form-item
            label="每日预算"
            prop="budget"
            :rules="[
              { required: true, message: '请输入每日预算', trigger: ['blur', 'change'] },
              $gjReRule(RE.num(2), '请输入两位小数正数'),
              $gjMinRule(1, '应大于等于1'),
            ]">
          <gj-input
              v-model="form.budget"
              width="334px"
              placeholder="请输入">
            <template #prepend>{{adStore.SD.currencySymbol}}</template>
          </gj-input>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
  import {formMixin, formRuleMixin} from "../../../../../../../../minxins";
  import {adStoreMixin} from "../../../../../common/mixin";
  import {AdCampaignEnum} from "../../../../../common/enum";
  import {disabledEndDate} from "../../../../../../../../utils/common";
  import {convertToDate} from "../../../../../../../../utils/date.util";

  export default {
    name: "app-campaign-base-info",
    mixins: [formMixin, adStoreMixin, formRuleMixin],
    props: {
      maxTime: {
        default: false
      }
    },
    data() {
      return {
        AdCampaignEnum: AdCampaignEnum,
        disabledEndDate: disabledEndDate(new Date()),
        startDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          return false
        },
        endDisabledDate: (time) => {
          let date = convertToDate(time) + " 23:59:59"
          if (this.maxTime && new Date(date).getTime() <= new Date(this.maxTime).getTime()) {// 按照站点时间计算，时间选项禁用掉过去时间的选择
            return true
          }
          if (new Date(date).getTime() <= new Date(this.form.startDate).getTime()) {
            return true
          }
          return false
        },
      };
    },
    methods: {
      formValidate() {
        let formValid = false;
        this.$refs.form.validate((valid) => {
          formValid = valid;
        });
        return formValid;
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .date-input-group .el-form-item__content {
    display: flex;
    align-items: center;
  }
  .form-row {
    display: flex;
    .form-col {
      padding-right: 100px;
    }
  }
</style>
